/* KUSTM small site script */
(function () {
  'use strict';

  // ---- smooth scroll for anchor links ----
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // ---- cart line controls (remove + qty) ----
  const form = document.querySelector('[data-kustm-cart-form]');
  if (!form) return;

  const lines = form.querySelector('[data-kustm-cart-lines]');
  const subtotalEl = form.querySelector('[data-kustm-subtotal]');
  const totalEl = form.querySelector('[data-kustm-total]');

  function formatMoney(cents) {
    // Shopify USD default; theme uses {{ ... | money }} so dollars+cents.
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function setBusy(busy) {
    form.classList.toggle('is-busy', !!busy);
  }

  async function changeLine(line, quantity) {
    setBusy(true);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!res.ok) throw new Error('cart change failed: ' + res.status);
      const cart = await res.json();
      // If we removed an item, the simplest reliable update is a reload —
      // line indexes shift after removal.
      if (Number(quantity) === 0) {
        window.location.reload();
        return;
      }
      // Otherwise patch line price + totals in-place.
      const lineEl = lines.querySelector(`[data-kustm-line="${line}"]`);
      if (lineEl) {
        const updatedItem = cart.items[Number(line) - 1];
        if (updatedItem) {
          const priceEl = lineEl.querySelector('[data-kustm-line-price]');
          if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
          const input = lineEl.querySelector('[data-kustm-qty-input]');
          if (input) input.value = updatedItem.quantity;
        }
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    } catch (err) {
      console.error('[kustm-cart]', err);
      window.location.reload();
    } finally {
      setBusy(false);
    }
  }

  // ---- remove button ----
  lines.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-kustm-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.getAttribute('data-line');
      changeLine(line, 0);
      return;
    }

    const dec = e.target.closest('[data-kustm-qty-dec]');
    const inc = e.target.closest('[data-kustm-qty-inc]');
    if (!dec && !inc) return;
    e.preventDefault();
    const lineEl = (dec || inc).closest('[data-kustm-line]');
    if (!lineEl) return;
    const input = lineEl.querySelector('[data-kustm-qty-input]');
    if (!input) return;
    const lineIdx = lineEl.getAttribute('data-kustm-line');
    let next = parseInt(input.value || '1', 10);
    next = isNaN(next) ? 1 : next;
    next = dec ? Math.max(0, next - 1) : next + 1;
    input.value = next;
    changeLine(lineIdx, next);
  });

  // ---- debounced input typing ----
  let debounceTimer = null;
  lines.addEventListener('input', (e) => {
    const input = e.target.closest('[data-kustm-qty-input]');
    if (!input) return;
    const lineIdx = input.getAttribute('data-line');
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      let qty = parseInt(input.value || '0', 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeLine(lineIdx, qty);
    }, 600);
  });
})();
